import _ from 'lodash';
export class ChecklistModel {
  constructor({
    id,
    tipoChecklist,
    tipoInstrumentoId,
    classificacaoInstrumentoId,
    itens,
    tipoInstrumento,
    classificacaoInstrumento
  }) {
    this.id = id;
    this.tipoChecklist = tipoChecklist;
    this.itens = [];
    if (this.id) this.itens = itens;

    this.tipoInstrumento = tipoInstrumento ? {
      value: tipoInstrumento.id,
      text: tipoInstrumento.nome
    } : null;
    this.tipoInstrumentoId = tipoInstrumentoId??tipoInstrumento?.value,

    this.classificacaoInstrumento = classificacaoInstrumento ? {
      value: classificacaoInstrumento.id,
      text: classificacaoInstrumento.descricao
    } : null;
    this.classificacaoInstrumentoId = classificacaoInstrumentoId??classificacaoInstrumento?.value;
  }
  
  get request() {
    let retorno = _.cloneDeep(this);
    if (typeof this.tipoChecklist !== 'number')
      retorno.tipoChecklist = retorno.tipoChecklist.value
        ? retorno.tipoChecklist.value
        : retorno.tipoChecklist;
    retorno.tipoInstrumentoId = retorno.tipoInstrumentoId?.value;
    retorno.classificacaoInstrumentoId =
      retorno.classificacaoInstrumentoId?.value;
    return retorno;
  }
  limparClassificacaoInstrumento() {
    this.classificacaoInstrumento = null;
    this.classificacaoInstrumentoId = null;
  }
  limparTipoInstrumento() {
    this.tipoInstrumento = null;
    this.tipoInstrumentoId = null;
  }
  formatarClassificacaoInstrumento() {
    if (this.classificacaoInstrumento) {
      this.classificacaoInstrumento = {
        id: this.classificacaoInstrumento.value,
        nome: this.classificacaoInstrumento.text
      };
      this.classificacaoInstrumentoId = this.classificacaoInstrumento.id
    }
  }
}
